import { NavLink } from "react-router-dom";
import {
    Database,
    Sun,
    MagnifyingGlass,
    ChartLine,
    EnvelopeSimple,
    SignOut,
    User,
    Shield,
} from "@phosphor-icons/react";
import { useAuth } from "@/lib/auth";

export default function TopNav({ isManagerOrAdmin, isAdmin }) {
    const { email, role, logout } = useAuth();
    return (
        <header className="sticky top-0 z-30 bg-white border-b border-[#e4e4e7]">
            <div className="flex items-center justify-between px-6 h-16">
                <div className="flex items-center gap-3">
                    <div className="w-9 h-9 bg-black flex items-center justify-center">
                        <Database size={18} weight="bold" color="#fff" />
                    </div>
                    <div className="flex flex-col leading-tight">
                        <span className="font-display text-lg font-bold tracking-tight">
                            ProvidersCSV
                        </span>
                        <span className="label-kicker" style={{ fontSize: 9 }}>
                            Service Provider Command Center
                        </span>
                    </div>
                </div>
                <nav className="flex items-center gap-1">
                    <NavLink
                        to="/today"
                        className={navCls}
                        data-testid="nav-today"
                    >
                        <Sun size={14} weight="bold" />
                        Today
                    </NavLink>
                    {isManagerOrAdmin && (
                        <NavLink
                            to="/performance"
                            className={navCls}
                            data-testid="nav-performance"
                        >
                            <ChartLine size={14} weight="bold" />
                            Performance
                        </NavLink>
                    )}
                    {isManagerOrAdmin && (
                        <NavLink
                            to="/digest"
                            className={navCls}
                            data-testid="nav-digest"
                        >
                            <EnvelopeSimple size={14} weight="bold" />
                            Digest
                        </NavLink>
                    )}
                    <NavLink
                        to="/search"
                        className={navCls}
                        data-testid="nav-search"
                    >
                        <MagnifyingGlass size={14} weight="bold" />
                        Search
                    </NavLink>
                    {isAdmin && (
                        <NavLink
                            to="/admin"
                            className={navCls}
                            data-testid="nav-admin"
                        >
                            <Shield size={14} weight="bold" />
                            Admin
                        </NavLink>
                    )}
                    <div
                        className="ml-3 flex items-center gap-2 px-3 py-1.5 mono text-[11px] border border-[#e4e4e7]"
                        data-testid="auth-identity"
                    >
                        <User size={13} weight="bold" />
                        <span className="text-[#52525b]">{role || "operator"}:</span>
                        <span className="font-bold" data-testid="auth-email">{email}</span>
                    </div>
                    <button
                        type="button"
                        onClick={logout}
                        className="btn-ghost"
                        title="Sign out"
                        data-testid="auth-logout"
                    >
                        <SignOut size={14} weight="bold" />
                    </button>
                </nav>
            </div>
        </header>
    );
}

const navCls = ({ isActive }) =>
    "inline-flex items-center gap-2 px-4 py-2 text-[12px] mono border " +
    (isActive
        ? "bg-black text-white border-black"
        : "border-transparent hover:border-[#e4e4e7]");
